import ApplyRounding from "../math/ApplyRounding";

export default function UpDownArrayIncrementDecrement(key, incrementAmount, currentValue, setter, roundDecimals) {
    if (key === "ArrowUp") {
        setter(ApplyRounding(currentValue + incrementAmount, roundDecimals))
    } else if (key === "ArrowDown") {
        if (currentValue === 0) {
            return;
        }
        setter(ApplyRounding(currentValue - incrementAmount, roundDecimals))
    }

}